export default "__VITE_ASSET__zV8qHqXn__"